import React, { Component } from "react";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";
import { connect } from "react-redux";
import { getLatestMessage } from "redux-flash";
import { Field, reduxForm } from "redux-form";
import { TextField } from "redux-form-material-ui";
import Button from "material-ui/Button";
import { CircularProgress } from "material-ui/Progress";

import CenteredForm from "../utils/form/CenteredForm";
import { required, email } from "../utils/form/formValidation";

import UserNotAuthenticated from "../utils/auth/UserNotAuthenticated";

import { loginRequest } from "./actions";

import styles from "./Login.scss";

import FontAwesome from "react-fontawesome";

const normalizeLower = (value) => value && value.toLowerCase();
const isDevEnvironment = process.env.NODE_ENV === "development";
class Login extends Component {
  static propTypes = {
    handleSubmit: PropTypes.func.isRequired,
    loginRequest: PropTypes.func.isRequired,
    login: PropTypes.shape({
      requesting: PropTypes.bool.isRequired,
    }).isRequired,
    snackbarMessage: PropTypes.objectOf(PropTypes.any).isRequired,
  };
  constructor() {
    super();
    this.state = {
      showMdp: false,
    };
  }

  submit = (values) => {
    this.props.loginRequest(values);
  };

  toggleShowMdp = () => {
    if (this.state.showMdp) {
      document.getElementById("Password").setAttribute("type", "password");
      document.getElementById("Eye").style.color = "#7a797e";
      this.setState({
        showMdp: false,
      });
    } else {
      document.getElementById("Password").setAttribute("type", "text");
      document.getElementById("Eye").style.color = "#5887ef";
      this.setState({
        showMdp: true,
      });
    }
  };

  render() {
    const {
      handleSubmit,
      login: { requesting },
      snackbarMessage,
    } = this.props;

    return (
      <div>
        <CenteredForm
          title=""
          handleOnSubmit={handleSubmit(this.submit)}
          snackbarMessage={snackbarMessage}
          className={styles.authForm}
        >
          <img className={styles.logo} src="./logo-new.png"></img>
          <h1 className={styles.titleLogin}>
            Le futur de l'information médicale.
          </h1>
          <h3
            style={{
              textAlign: "center",
              color: "#888",
              alignSelf: "flex-start",
              marginBottom: "20px",
            }}
          >
            Les cabinets médicaux les plus innovants sont sur Digidocteur.
          </h3>
          <div className="mb2">
            <Field
              name="email"
              placeholder="Email"
              label="Email"
              inputProps={{
                autoCorrect: "off",
                autoCapitalize: "none",
              }}
              component={TextField}
              validate={[required, email]}
              normalize={normalizeLower}
              fullWidth
            />
          </div>
          <div className="mb3" id={styles.PasswordField}>
            <Field
              name="password"
              id="Password"
              type="password"
              placeholder="Mot de passe"
              label="Mot de passe"
              inputProps={{
                autoCorrect: "off",
                autoCapitalize: "none",
              }}
              component={TextField}
              validate={required}
              fullWidth
            />
            <div id="SpanIcon" className={styles.spanIcon}>
              <FontAwesome
                id="Eye"
                style={{ color: "#7a797e" }}
                className="fas fa-eye"
                name="eye"
                onClick={() => this.toggleShowMdp()}
              />
            </div>
          </div>
          <Button
            type={requesting ? "" : "submit"}
            className="mb6"
            variant="raised"
            color="primary"
            fullWidth
          >
            {!requesting && "Connexion"}
            {requesting && <CircularProgress className={styles.requesting} />}
          </Button>
          <Button
            color="primary"
            root="true"
            href="/password-recovery"
            className={styles.linkPasswordRecovery}
          >
            Mot de passe oublié ?
          </Button>
          {isDevEnvironment && (
            <div>
              <Button
                root="true"
                color="primary"
                href="/signup"
                className={styles.noAccountYet}
              >
                Pas encore de compte? Cliquez ici pour vous abonner
              </Button>
            </div>
          )}
        </CenteredForm>
        <style
          dangerouslySetInnerHTML={{
            __html: `
      body{
        background-image: url("/background.jpg");
        background-size: cover;
        background-color: rgb(192, 199, 203) !important;
      }
      `,
          }}
        />
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  login: state.login,
  snackbarMessage: getLatestMessage(state) || {},
});

const ConnectedLogin = connect(mapStateToProps, { loginRequest })(
  UserNotAuthenticated(Login)
);

export default reduxForm({
  form: "login",
})(ConnectedLogin);



// WEBPACK FOOTER //
// ./src/pages/login/Login.jsx